import React from 'react'
function Head() {
    return (
        <div>
        <footer>
            <div class="container d-flex align-center justify-between fot-fdiv">
                <figure>
                    <img src="./images/logo.svg" class="img-responsive" alt="fot-logo"></img>
                </figure>
                 <div class="upp-ul d-flex align-start justify-between">
                    {/* <ul class="list-none">
                        <h5>ABOUT</h5>
                        <li>About Us</li>
                        <li>Membership</li>
                        <li>Market</li>
                        <li>Contact Us</li>
                    </ul>
                    <ul class="list-none">
                        <h5>HELP</h5>
                        <li>Terms & Conditions</li>
                        <li>Privacy Policy</li>
                        <li>Contact Us</li>
                    </ul>
                    <ul class="list-none">
                        <h5>CONTACT</h5>
                        <li>Suppor@controlhub.com</li>
                        <li>FAQ</li>
                    </ul> */}
                    <ul class="list-none">
                        <a href="https://www.auctionsoftware.com/contact-us/" target="_Blank"><h5 class="yellow-clr">Contact Us </h5></a>
                        {/* <div class="d-flex justify-around">
                            
                            <li><img src="./images/fb.png" class="img-responsive" alt="facebook"></img></li>
                            <li><img src="./images/insta.png" class="img-responsive" alt="facebook"></img></li>
                            <li><img src="./images/indeed.png" class="img-responsive" alt="facebook"></img></li>
                            <li><img src="./images/tweet.png" class="img-responsive" alt="facebook"></img></li>
                        </div> */}
                    </ul>
                </div>
            </div>
        </footer>
        
        <div class="footer text-right text-sm-center">
            <b>Copyright © 2020 Auction Software, Inc. All Rights Reserved.</b>
        </div></div>);
  }
  export default Head;